import { BaseExpandableRow } from '@/components/_Shared/Table/UI/ExpandableRow/ExpandableRow'
import { ExpandableRowButtonContainer } from '@/components/_Shared/Table/UI/ExpandableRow/ExpandableRowButtonContainer'
import { OrangeButton, RouteButton } from '@/components/Buttons'
import { PointOfContactProps } from '@/interfaces/point-of-contact_types.ts'
import { deletePointOfContact } from '@/api/point-of-contact'

export const PointOfContactRow = ({ data }: { data: PointOfContactProps }) => {
    const handleDelete = async() => {
        if (confirm("Are you sure you want to delete this Point of Contact?")) {
            const response = await deletePointOfContact(data.uuid)
            if (response.operation == "COMPLETED") {
                alert("Point of Contact deleted successfully")
                window.location.reload()
            } else {
                alert("Failed to delete Point of Contact: " + response.message)
            }
        }
    }
    return (
        <BaseExpandableRow>
            <ExpandableRowButtonContainer>
                <RouteButton route={"/point_of_contact/update/" + data.uuid} text="Edit" />
                <OrangeButton onClick={handleDelete}>
                    Delete Point of Contact
                </OrangeButton>
            </ExpandableRowButtonContainer>
        </BaseExpandableRow>
    )
}